import { createBrowserRouter } from 'react-router-dom';
import { Trans } from '@lingui/react/macro';

export const router = createBrowserRouter([
  {
    path: '/invite',
    lazy: () => import('../components/InviteLanding').then((m) => ({ Component: m.default })),
  },
  {
    path: '/',
    lazy: () => import('../App').then((m) => ({ Component: m.AppShell })),
  },
  {
    path: '/dm',
    lazy: () => import('../App').then((m) => ({ Component: m.AppShell })),
  },
  {
    path: '/dm/:dmChannelId',
    lazy: () => import('../App').then((m) => ({ Component: m.AppShell })),
  },
  {
    path: '/me',
    lazy: () => import('../App').then((m) => ({ Component: m.AppShell })),
  },
  {
    path: '/me/tasks',
    lazy: () => import('../App').then((m) => ({ Component: m.AppShell })),
  },
  {
    path: '/me/agents',
    lazy: () => import('../App').then((m) => ({ Component: m.AppShell })),
  },
  {
    path: '/s/:guildId/tasks',
    lazy: () => import('../App').then((m) => ({ Component: m.AppShell })),
  },
  {
    path: '/s/:guildId',
    lazy: () => import('../App').then((m) => ({ Component: m.AppShell })),
  },
  {
    path: '/s/:guildId/insights',
    lazy: () => import('../App').then((m) => ({ Component: m.AppShell })),
  },
  {
    path: '/s/:guildId/members',
    lazy: () => import('../App').then((m) => ({ Component: m.AppShell })),
  },
  {
    path: '/s/:guildId/members/:memberId',
    lazy: () => import('../App').then((m) => ({ Component: m.AppShell })),
  },
  {
    path: '/me/agents/:agentId',
    lazy: () => import('../App').then((m) => ({ Component: m.AppShell })),
  },
  {
    path: '/me/computers',
    lazy: () => import('../App').then((m) => ({ Component: m.AppShell })),
  },
  {
    path: '/me/computers/:computerId',
    lazy: () => import('../App').then((m) => ({ Component: m.AppShell })),
  },
  {
    path: '/s/:guildId/channel/:channelId',
    lazy: () => import('../App').then((m) => ({ Component: m.AppShell })),
  },
  {
    path: '/s/:guildId/channel/:channelId/thread/:threadId',
    lazy: () => import('../App').then((m) => ({ Component: m.AppShell })),
  },
  {
    path: '/s/:guildId/settings',
    lazy: () => import('../App').then((m) => ({ Component: m.AppShell })),
  },
  {
    path: '/s/:guildId/settings/profile',
    lazy: () => import('../App').then((m) => ({ Component: m.AppShell })),
  },
  {
    path: '/s/:guildId/settings/channels',
    lazy: () => import('../App').then((m) => ({ Component: m.AppShell })),
  },
  {
    path: '/s/:guildId/settings/members',
    lazy: () => import('../App').then((m) => ({ Component: m.AppShell })),
  },
  {
    path: '/s/:guildId/invitations',
    lazy: () => import('../App').then((m) => ({ Component: m.AppShell })),
  },
  {
    path: '/s/:guildId/*',
    lazy: () => import('../App').then((m) => ({ Component: m.AppShell })),
  },
  {
    path: '/me/*',
    element: (
      <main className="no-channel">
        <h1>
          <Trans>Page not found</Trans>
        </h1>
        <a href="/me">
          <Trans>Open overview</Trans>
        </a>
      </main>
    ),
  },
  {
    path: '*',
    lazy: () => import('../App').then((m) => ({ Component: m.AppShell })),
  },
]);
